import { render } from "./FooTer.vue?vue&type=template&id=1604e4ed"
import script from "./FooTer.vue?vue&type=script&lang=js"
export * from "./FooTer.vue?vue&type=script&lang=js"

import "./FooTer.vue?vue&type=style&index=0&id=1604e4ed&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__